import moment from 'moment'
import { path, prop, reject, head, propEq } from 'ramda'
import { Trans } from 'react-i18next'
import { useSelector } from 'react-redux'
import styled from 'styled-components'
import { breakpoints, fontWeights, colors } from '@/styles'
import AddendumAgreement from './addendum-agreement'
import AddendumDescription from './addendum-description'

const Title = styled.h1`
  color: ${colors.regular};
  text-align: center;
  font-weight: ${fontWeights.bold};
  font-size: 26px;
  letter-spacing: -0.2px;
  line-height: 36px;
  margin: 0 0 30px;
  word-break: break-word;

  @media screen and (max-width: ${breakpoints.phoneMax}) {
    font-size: 24px;
    letter-spacing: -0.4px;
    line-height: 33px;
  }
`

const AgreeText = styled.p`
  color: ${colors.regular};
  font-weight: ${fontWeights.medium};
  margin: 30px 0 20px;
`

const DateSignedText = styled.span`
  font-weight: 600;
`

const AddendumView = ({ contractId, addendum, onChange, variables, signed = false }) => {
  const userId = useSelector(path(['session', 'session', 'id']))

  const contractSignature = useSelector(path(['contract', contractId, 'contract_signatures']))

  const getSignatureDate = () => {
    const otherPartySignature = prop(
      'created_at',
      head(reject(propEq('user_id', userId), contractSignature))
    )
    return moment(otherPartySignature).format('MMMM DD, YYYY')
  }
  const dateSigned = signed ? getSignatureDate() : ''

  return (
    <>
      <Title>{addendum.title}</Title>
      <AddendumDescription addendum={addendum} variables={variables} />
      {signed && (
        <AgreeText htmlFor={`addendum-${addendum.id}`}>
          <Trans i18nKey="r.contract.view.agree_with_addendum_terms.text" dateSigned={dateSigned}>
            This addendum has been agreed to on <DateSignedText>{{ dateSigned }}</DateSignedText>.
          </Trans>
        </AgreeText>
      )}
      {onChange && <AddendumAgreement addendum={addendum} onChange={onChange} />}
    </>
  )
}

AddendumView.defaultProps = {
  addendum: {},
  onChange: null,
  variables: {}
}

export default AddendumView
